"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.howManyDaysArePast = void 0;
var cumulative_day_of_year_1 = require("./cumulative-day-of-year");
function howManyDaysArePast(month, day) {
    return cumulative_day_of_year_1.cumulative[month - 1] + day;
}
exports.howManyDaysArePast = howManyDaysArePast;
